import { StyleSheet } from 'aphrodite';
import { nameCircles } from '../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		maxWidth: 1024,
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
		marginBottom: 24,
	},
	buttonGroup: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		gap: 12,
		marginTop: 24,
	},
	eventResponseMessage: {
		'@media only screen and (min-width: 768px)': {
			flexDirection: 'row',
			margin: '24px auto 24px',
			maxWidth: 1024,
			padding: 24,
		},
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		marginLeft: 0,
		marginRight: 0,
		marginTop: 24,
		marginBottom: 24,
		padding: 12,
		borderRadius: 3,
	},
	divider: {
		maxWidth: 1024,
		width: '100%',
		borderTop: `2px solid ${nameCircles}`,
	},
});
